import { bigNumberFromUnknown, formatTokenFloor } from './swapUtils';

const POSSIBLE_AMOUNT_OUT_KEYS = [
  'assumedAmountOut',
  'amountOut',
  'outputAmount',
  'toAmount',
  'outAmount',
  'amountOutMin',
];

function findAmountLike(value, depth = 0) {
  if (!value || depth > 5) return null;
  if (typeof value === 'object') {
    for (const key of POSSIBLE_AMOUNT_OUT_KEYS) {
      const candidate = bigNumberFromUnknown(value[key]);
      if (candidate !== null) return candidate;
    }
    for (const child of Object.values(value)) {
      const found = findAmountLike(child, depth + 1);
      if (found !== null) return found;
    }
  }
  return null;
}

export function extractExpectedTokenOutAmount(swapData) {
  return findAmountLike(swapData);
}

export function toDisplayAmount(amountBN) {
  if (!amountBN) return 0;
  return formatTokenFloor(amountBN, 18);
}
